import { render, staticRenderFns } from "./RecentlyAddedCategoryContent.vue?vue&type=template&id=45047e70&scoped=true&"
import script from "./RecentlyAddedCategoryContent.vue?vue&type=script&lang=js&"
export * from "./RecentlyAddedCategoryContent.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyAddedCategoryContent.vue?vue&type=style&index=0&id=45047e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45047e70",
  null
  
)

export default component.exports